import React from 'react';
import { Box, IconButton, Menu, MenuButton, MenuList } from '@chakra-ui/react';
import KebabMenuIcon from '../../icons/KebabIcon/KebabIcon';
import { useTokens } from '../../../context/TokenProvider';
import { localise } from '../../../services/lang/lang';
export const TableActionMenu = (props) => {
    const tokens = useTokens();
    return (React.createElement(Box, null,
        React.createElement(Menu, null,
            React.createElement(MenuButton, { onClick: (e) => e.stopPropagation(), as: IconButton, "data-testid": "table_action_menu__kebab_button", colorScheme: tokens.Layer01, "aria-label": localise('TABLE_ROW_ACTIONS'), icon: React.createElement(KebabMenuIcon, null), minHeight: "auto", height: "auto" }),
            React.createElement(MenuList, null, props.children))));
};
